import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {Principal, User, UserService} from '../../shared';

@Component({
    selector: 'jhi-user-mgmt',
    templateUrl: './user-management.component.html'
})
export class UserMgmtComponent implements OnInit {

    currentAccount: any;
    users: User[];
    error: any;
    success: any;
    isSaving = false;

    filtreUtilisateurEns = true;
    public isGestionnaire: Boolean = false ;

    constructor(private jhiLanguageService: JhiLanguageService,
                private userService: UserService,
                private alertService: AlertService,
                private principal: Principal,
                private eventManager: EventManager) {
        this.jhiLanguageService.setLocations(['user-management']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.isGestionnaire = Principal.isAnyAuthorityInListe(
                ['ROLE_GEST', 'ROLE_SYSTEM', 'ROLE_ADMIN'], this.currentAccount.authorities) ;
            this.loadAll();
            this.registerChangeInUsers();
        });
    }

    registerChangeInUsers() {
        this.eventManager.subscribe('userListModification', (response) => this.loadAll());
    }

    setActive(user, isActivated) {
        user.activated = isActivated;
        this.updateUser(user);
    }


    setPluriannuel(user, isPluriannuel) {
        user.pluriannuel = isPluriannuel;
        this.updateUser(user);
    }


    private updateUser(user) {
        this.userService.update(user).subscribe(
            (res: Response) => {
                    this.error = null;
                    this.success = 'OK';
                    this.onRefreshUser(res.json(), res.headers);
            },
            (res: Response) => {
                this.onError(res.json());
                this.loadAll() ;
            });
    }

    loadAll() {
        this.isSaving = true;
        this.userService.query({userENS: this.filtreUtilisateurEns}).subscribe(
            (res: Response) => {
                this.onSuccess(res.json(), res.headers);
                this.isSaving = false;
            },
            (res: Response) => {
                this.onError(res.json());
                this.isSaving = false;
            }
        );
    }

    private onRefreshUser(data, headers) {
        let refreshedUser: User = data;
        if (refreshedUser != null){
            let index = this.users.findIndex(user => user.id === refreshedUser.id);
            if (index > 0) {
                this.users[index] = refreshedUser;
            }
        }
    }

    private onSuccess(data, headers) {
        this.users = data;
    }

    private onError(error) {
        this.alertService.error(error.error, error.message, null);
    }

    // filtre sur année en cours
    onChangeFiltreUtilisateurEns(value) {
        this.filtreUtilisateurEns = value;
        this.loadAll();
    }

    // noinspection JSMethodCanBeStatic
    userPeutCandidater(user: User): Boolean {
        return User.userPeutCandidater(user);
    }

    // noinspection JSMethodCanBeStatic
    userResinscription(user: User): Boolean {
        return User.userResinscription(user);
    }

 }



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management.component.ts